import React from "react"
import Accordion, { AccordionItem } from "../../../UI/Accordion/Accordion";

import * as styles from "./AboutCompany.module.scss"
import { useIntl } from "gatsby-plugin-intl";


const AboutCompany = () => {
	const intl = useIntl()
	const items: AccordionItem[] = [
		{
			title: intl.formatMessage({ id: "index.about.tabs.first-title" }),
			content: intl.formatMessage({ id: "index.about.tabs.first-text" }),
		},
		{
			title: intl.formatMessage({ id: "index.about.tabs.second-title" }),
			content: intl.formatMessage({ id: "index.about.tabs.second-text" }),
		},
		{
			title: intl.formatMessage({ id: "index.about.tabs.third-title" }),
			content: intl.formatMessage({ id: "index.about.tabs.third-text" }),
		},
		{
			title: intl.formatMessage({ id: "index.about.tabs.forth-title" }),
			content: intl.formatMessage({ id: "index.about.tabs.forth-text" }),
		},
	]
	return (
		<section className={styles.aboutCompany}>
			<h2>{intl.formatMessage({ id: "index.about.title" })}</h2>
			<div className={styles.aboutCompanyText}>
				<p>
					{intl.formatMessage({ id: "index.about.text-one" })}
				</p>
				<p>
					{intl.formatMessage({ id: "index.about.text-two" })}
				</p>
			</div>
			<Accordion items={items} defaultOpenIndexes={[0]} />



		</section>
	);
}

export default AboutCompany;